import axios from 'axios'
import WebTrekk from '@/plugins/webtrekk/WebTrekk'

const PARAMETERS = {
    ERROR_EVENT_ID: 'benutzerverwaltung_error_message',
    ERROR: 'benutzerverwaltung_error',
    IBAN_REGEX: new RegExp('[A-Z]{2}[0-9]{2}[A-Z0-9]{11,30}', 'ig'),
    EMAIL_REGEX: new RegExp(
        '[A-Z0-9\\._-]{1,50}@[A-Z0-9\\._-]{1,50}\\.[A-Z0-9]{2,12}',
        'ig'
    )
}

const Webtrekk = {
    install(app, options) {
        app.config.globalProperties.$wt = WebTrekk // Add Webtrekk to app's global properties

        axios.interceptors.response.use(
            response => {
                return response
            },
            error => {
                const errorData = this._parseErrorInformation(error)
                /**
                 * | Parameter ID | Mapp Titel |
                 * | ------------ | ---------- |
                 * | 2  | Cbra HTTP-Status Code   |
                 * | 3  | Fehlermeldung (Aktion)  |
                 * | 5  | Status                  |
                 * | 6  | Seitenfunktion (Aktion) |
                 * | 7  | Seitenaktion (Aktion)   |
                 * | 8  | Aktionsbeschreibung     |
                 * | 13 | ASK HTTP-Status Code    |
                 * | 14 | ASK Status              |
                 * | 15 | ASK Status Message      |
                 * | 16 | ASK Status Hint         |
                 * | 17 | Fehler                  |
                 */
                WebTrekk.action({
                    name: PARAMETERS.ERROR_EVENT_ID,
                    parameter: {
                        2: errorData.restHttpStatusCode,
                        3: '-',
                        5: errorData.status,
                        6: PARAMETERS.ERROR,
                        7: errorData.uri,
                        8: errorData.logId,
                        13: errorData.askHttpStatusCode,
                        14: errorData.askStatus,
                        15: errorData.askStatusMessage,
                        16: errorData.askStatusHint,
                        17: errorData.errorMessage
                    }
                })
                WebTrekk.trackAction()

                return Promise.reject(error)
            }
        )
    },

    /**
     * Parse error information.
     *
     * @param {Object} [error]
     * @return {Object}
     * @private
     */
    _parseErrorInformation(error = null) {
        let errorData = {
            uri: '-',
            status: '0',
            errorMessage: '',
            logId: '-',
            restHttpStatusCode: '0',
            askHttpStatusCode: '0',
            askStatus: '-',
            askStatusMessage: '-',
            askStatusHint: '-'
        }

        if (typeof error !== 'object' || error === null) {
            return errorData
        }

        if (typeof error.message === 'string') {
            errorData.errorMessage = error.message.substring(0, 250)
        }

        if (typeof error.response !== 'object' || error.response === null) {
            if (error.request instanceof XMLHttpRequest) {
                if (
                    typeof error.request.responseURL === 'string' &&
                    error.request.responseURL.length
                ) {
                    errorData.uri = error.request.responseURL
                    if (errorData.uri.indexOf('?') >= 0) {
                        errorData.uri = errorData.uri.substring(
                            0,
                            errorData.uri.indexOf('?')
                        )
                    }
                    errorData.uri = errorData.uri.replace(
                        new RegExp('[0-9]+', 'g'),
                        'XXXX'
                    )
                }
            }

            return errorData
        }

        if (typeof error.response.status === 'number') {
            errorData.status = 'RestHTTP ' + String(error.response.status)
            errorData.restHttpStatusCode = String(error.response.status)
        }
        if (
            typeof error.response.statusText === 'string' &&
            error.response.statusText.length
        ) {
            errorData.errorMessage = error.response.statusText.substring(0, 250)
        }

        if (
            typeof error.response.config === 'object' &&
            error.response.config !== null
        ) {
            if (
                typeof error.response.config.url === 'string' &&
                error.response.config.url.length
            ) {
                errorData.uri = error.response.config.url
                if (errorData.uri.indexOf('?') >= 0) {
                    errorData.uri = errorData.uri.substring(
                        0,
                        errorData.uri.indexOf('?')
                    )
                }
                errorData.uri = errorData.uri.replace(
                    new RegExp('[0-9]+', 'g'),
                    'XXXX'
                )
            }
        }

        if (
            typeof error.response.headers === 'object' &&
            error.response.headers !== null
        ) {
            if (
                typeof error.response.headers.correlationId === 'string' &&
                error.response.headers.correlationId.length
            ) {
                errorData.logId = error.response.headers.correlationId
            } else if (
                typeof error.response.headers.log_id === 'string' &&
                error.response.headers.log_id.length
            ) {
                errorData.logId = error.response.headers.log_id
            }
        }

        if (
            typeof error.response.data !== 'object' ||
            error.response.data === null
        ) {
            return errorData
        }

        let askStatus = {}
        if (
            typeof error.response.data.askStatus === 'object' &&
            error.response.data.askStatus !== null
        ) {
            askStatus = error.response.data.askStatus
        } else if (typeof error.response.data.httpStatus === 'number') {
            askStatus = error.response.data
        }

        if (typeof askStatus.httpStatus === 'number') {
            errorData.askHttpStatusCode = String(askStatus.httpStatus)
        }
        if (typeof askStatus.statusHint === 'string') {
            errorData.askStatusHint = this._filterStatusMessages(
                askStatus.statusHint
            )
        }
        if (askStatus.statusElements instanceof Array) {
            if (
                typeof askStatus.statusElements[0] === 'object' &&
                askStatus.statusElements[0] !== null
            ) {
                if (
                    typeof askStatus.statusElements[0].statusCode === 'string'
                ) {
                    errorData.askStatus =
                        askStatus.statusElements[0].statusCode.substring(0, 250)
                }
                if (
                    typeof askStatus.statusElements[0].statusMessage ===
                    'string'
                ) {
                    errorData.askStatusMessage = this._filterStatusMessages(
                        askStatus.statusElements[0].statusMessage
                    )
                } else if (
                    typeof askStatus.statusElements[0].message === 'string'
                ) {
                    errorData.askStatusMessage = this._filterStatusMessages(
                        askStatus.statusElements[0].message
                    )
                } else if (
                    typeof askStatus.statusElements[0].fieldName === 'string'
                ) {
                    errorData.askStatusMessage = this._filterStatusMessages(
                        askStatus.statusElements[0].fieldName
                    )
                }
            }
        }

        if (errorData.askStatus.length && errorData.askStatus !== '-') {
            errorData.status = errorData.askStatus
        } else if (errorData.askHttpStatusCode > 0) {
            errorData.status = 'AskHTTP ' + errorData.askHttpStatusCode
        }
        if (
            errorData.askStatusMessage.length &&
            errorData.askStatusMessage !== '-'
        ) {
            errorData.errorMessage = errorData.askStatusMessage
        }

        if (
            error.response.data instanceof Array &&
            error.response.data.length &&
            error.response.data[0].errorCode &&
            error.response.data[0].errorCode.length
        ) {
            errorData.errorMessage = error.response.data[0].errorCode
        }

        return errorData
    },

    _filterStatusMessages(message) {
        if (message.length < 10) {
            return message
        }
        const matchIban = message.match(PARAMETERS.IBAN_REGEX)
        if (matchIban instanceof Array) {
            matchIban.forEach(iban => {
                message = message.replace(
                    iban,
                    iban.substring(0, 2) + ''.padEnd(iban.length - 2, 'X')
                )
            })
        }
        const matchEmail = message.match(PARAMETERS.EMAIL_REGEX)
        if (matchEmail instanceof Array) {
            matchEmail.forEach(email => {
                message = message.replace(email, 'XXXXX@YYYYY.ZZ')
            })
        }

        return message.substring(0, 250)
    }
}

export default Webtrekk
